/*
 * "Complete your set" in the cart drawer, on the cart page, and as a pop-up after
 * each add (snippets/complete-your-set.liquid, snippets/cys-popup.liquid).
 * Suggestions come from the shared rules (assets/upsell-rules.js) and the data in
 * snippets/upsell-data.liquid.
 *
 * The block carries the cart it was rendered with, so it redraws itself every time
 * the theme re-renders the drawer or cart page. When the rules have nothing to
 * suggest, the drawer's "You may also like" ([data-cys-fallback]) shows.
 *
 * The landing page (assets/lp-v2.js) opens this same pop-up after its adds.
 *
 * Pop-up vs no pop-up test: FlabUpsell.variant() is 'popup', 'control' or null.
 * - 'popup': every add (landing page included) opens the pop-up instead of the drawer.
 * - 'control': every add opens the cart drawer (the landing page too).
 * - null (no flag set, flag not loaded, or analytics declined): the landing page
 *   opens the pop-up and the rest of the site opens the drawer.
 * The drawer and cart page keep "Complete your set" in every variant.
 * The variant comes from the PostHog flag named in Theme settings → Complete your
 * set → Test flag. ?cys_ux=popup|control previews a variant for the visit;
 * ?cys_ux=off clears it.
 *
 * Also loads the best-selling order of sets and flabs once per visit and exposes
 * window.FlabUpsell { data, ready, soldOut, variant, openPopup } for the landing page (assets/lp-v2.js).
 *
 * Tracking (PostHog): upsell_viewed when suggestions are on screen, upsell_added
 * on each Add. Both carry surface (cart_drawer | cart_page | popup) and ux_variant
 * (popup | control | default). Pop-up adds on the landing page also send lp_add_to_cart
 * (placement complete_your_set, upsell = kind), as the landing page's own pop-up did.
 */
(function () {
  var DATA = null;
  try { DATA = JSON.parse(document.getElementById('FlabUpsellData').textContent); } catch (e) {}
  var soldOut = {};

  function track(event, props) {
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(event, props);
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // ---- Which version: preview override, else the PostHog flag, else null ----
  var OVERRIDE_KEY = 'cys-ux';
  (function readOverride() {
    var m = /[?&]cys_ux=(popup|control|off)\b/.exec(location.search);
    if (!m) return;
    try {
      if (m[1] === 'off') sessionStorage.removeItem(OVERRIDE_KEY); else sessionStorage.setItem(OVERRIDE_KEY, m[1]);
    } catch (e) {}
  })();
  function variant() {
    try {
      var o = sessionStorage.getItem(OVERRIDE_KEY);
      if (o === 'popup' || o === 'control') return o;
    } catch (e) {}
    var flag = DATA && DATA.test_flag;
    if (flag && window.posthog && typeof window.posthog.getFeatureFlag === 'function') {
      var v = window.posthog.getFeatureFlag(flag);
      if (v === 'popup' || v === 'control') return v;
    }
    return null;
  }

  // ---- Best-selling order (templates/collection.lp-order.liquid), cached for the visit ----
  function sortByHandles(list, handles) {
    var rank = {};
    handles.forEach(function (h, i) { rank[h] = i; });
    list.sort(function (a, b) {
      return (rank[a.handle] === undefined ? 999 : rank[a.handle]) - (rank[b.handle] === undefined ? 999 : rank[b.handle]);
    });
  }
  function loadOrder(url) {
    if (!url) return Promise.resolve(null);
    var key = 'flab-upsell-order:' + url;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key));
      if (Array.isArray(cached)) return Promise.resolve(cached);
    } catch (e) {}
    // No Accept: application/json here, or Shopify answers with its own collection JSON.
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (handles) {
        if (!Array.isArray(handles)) return null;
        try { sessionStorage.setItem(key, JSON.stringify(handles)); } catch (e) {}
        return handles;
      })
      .catch(function () { return null; });
  }
  var ready = !DATA ? Promise.resolve(null) : Promise.all([loadOrder(DATA.set_order_url), loadOrder(DATA.flab_order_url)])
    .then(function (orders) {
      if (orders[0]) sortByHandles(DATA.sets || [], orders[0]);
      if (orders[1]) sortByHandles(DATA.flabs || [], orders[1]);
      return DATA;
    });

  window.FlabUpsell = { data: DATA, ready: ready, soldOut: soldOut, variant: variant };

  if (!DATA || !DATA.enabled || !window.FlabUpsellRules) return;

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // ---- upsell_viewed: once per drawer or pop-up opening (or page view) per set of suggestions ----
  var seen = {};
  function drawerOpen() {
    var d = document.getElementById('CartDrawer');
    return !!(d && d.hasAttribute('open'));
  }
  function trackView(block) {
    var surface = block.surface;
    if (!block.items.length) return;
    if (surface === 'cart_drawer' && !drawerOpen()) return;
    var sig = block.items.map(function (a) { return a.kind + ':' + a.handle; }).join(',');
    if (seen[surface] === sig) return;
    seen[surface] = sig;
    track('upsell_viewed', {
      surface: surface,
      ux_variant: variant() || 'default',
      upsell_kinds: block.items.map(function (a) { return a.kind; }),
      product_handles: block.items.map(function (a) { return a.handle; }),
      suggestion_count: block.items.length
    });
  }
  function watchDrawer() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    new MutationObserver(function () {
      if (!d.hasAttribute('open')) { seen.cart_drawer = null; return; }
      var block = d.querySelector('complete-your-set');
      if (block && block.items) trackView(block);
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }

  // ---- The suggestion list (block and pop-up) ----
  function renderList(list, items, onAdd) {
    list.innerHTML = '';
    items.forEach(function (a, i) {
      var li = document.createElement('li');
      li.className = 'cys__item';
      var img = a.image ? document.createElement('img') : document.createElement('span');
      if (a.image) { img.src = a.image; img.alt = ''; img.loading = 'lazy'; img.width = 56; img.height = 56; } else { img.className = 'cys__ph'; }
      var text = document.createElement('div');
      text.className = 'cys__text';
      var name = document.createElement('strong');
      name.textContent = a.title + ' · ' + a.price_text;
      text.appendChild(name);
      if (a.note) { var n = document.createElement('span'); n.className = 'cys__note'; n.textContent = a.note; text.appendChild(n); }
      if (a.unlocks) { var tag = document.createElement('span'); tag.className = 'cys__tag'; tag.textContent = 'Gets you free shipping'; text.appendChild(tag); }
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cys__btn';
      btn.textContent = 'Add';
      btn.setAttribute('aria-label', 'Add ' + a.title + ', ' + a.price_text);
      btn.addEventListener('click', function () { onAdd(a, btn, i + 1); });
      li.appendChild(img); li.appendChild(text); li.appendChild(btn);
      list.appendChild(li);
    });
  }

  // ---- Add a suggestion ----
  var status = {}; // "Added: …" per surface, shown by the re-rendered block
  function add(block, a, btn, position) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    track('upsell_added', {
      surface: block.surface,
      ux_variant: variant() || 'default',
      upsell: a.kind,
      product_handle: a.handle,
      quantity: a.qty,
      position: position,
      price: a.price / 100,
      unlocks_free_shipping: !!a.unlocks
    });
    // Keep the landing page's funnel events (snippets/posthog.liquid drains window.lpq there).
    if (block === popup && document.querySelector('.lpv2')) {
      (window.lpq = window.lpq || []).push(['lp_add_to_cart', { product_handle: a.handle, placement: 'complete_your_set', quantity: a.qty, upsell: a.kind, ux_variant: variant() || 'default' }]);
    }

    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(a.variant), quantity: a.qty }], sections: sections.join(','), sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, status: r.status, body: body }; }); })
      .then(function (res) {
        var error = null;
        if (!res.ok) {
          error = (res.body && (res.body.description || res.body.message)) || 'Something went wrong. Please try again.';
          if (res.status === 422 || /sold out|already sold|not available/i.test(error)) soldOut[a.handle] = true;
        } else {
          status[block.surface] = 'Added: ' + a.title;
        }
        return getCart().then(function (cart) {
          // Use the re-rendered sections only if every one came back; otherwise refresh the drawer.
          var secs = res.body && res.body.sections;
          var keys = secs ? Object.keys(secs) : [];
          if (!error && keys.length && keys.every(function (k) { return secs[k]; })) cart.sections = secs;
          if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'complete-your-set', cart: cart });
          }
          if (!error && !cart.sections) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
          if (error || block === popup) {
            // The pop-up isn't part of a theme section, and a failed add re-renders nothing:
            // redraw from the fresh cart.
            block.cart = cart;
            if (block === popup && !error) popup.added = a.title;
            block.render(error);
            btn.removeAttribute('aria-busy');
          }
        });
      })
      .catch(function () {
        block.render('Something went wrong. Please try again.');
        btn.removeAttribute('aria-busy');
      });
  }

  // ---- The block (cart drawer, cart page) ----
  class CompleteYourSet extends HTMLElement {
    get surface() { return this.getAttribute('data-surface') || 'cart_drawer'; }

    get fallback() { return this.querySelector('[data-cys-fallback]'); }

    connectedCallback() {
      try { this.cart = JSON.parse(this.querySelector('[data-cys-cart]').textContent); } catch (e) { this.cart = null; }
      this.items = [];
      // Just added from this surface: announce it and keep focus here, not on the first cart line.
      this.statusText = status[this.surface] || '';
      status[this.surface] = '';
      this.render();
      if (this.statusText) {
        var heading = this.querySelector('.cys__heading');
        requestAnimationFrame(function () { if (heading && heading.offsetParent) heading.focus(); });
      }
      var self = this;
      ready.then(function () { if (self.isConnected) self.render(); });
    }

    render(error) {
      var items = window.FlabUpsellRules.suggestions(this.cart, DATA, { soldOut: soldOut });
      this.items = items;
      var fallback = this.fallback;
      if (fallback) fallback.hidden = items.length > 0;

      this.querySelector('[data-cys-rules]').hidden = items.length === 0 && !error;
      this.querySelector('.cys__heading').textContent = window.FlabUpsellRules.heading(this.cart);
      var err = this.querySelector('[data-cys-error]');
      err.hidden = !error;
      err.textContent = error || '';
      var msg = this.querySelector('[data-cys-status]');
      if (msg) msg.textContent = this.statusText || '';

      var self = this;
      renderList(this.querySelector('[data-cys-list]'), items, function (a, btn, position) { add(self, a, btn, position); });
      trackView(this);
    }
  }
  if (!customElements.get('complete-your-set')) customElements.define('complete-your-set', CompleteYourSet);

  // ---- The pop-up (after landing page adds, and after every add in the pop-up variant) ----
  var popup = {
    surface: 'popup',
    cart: null,
    items: [],
    added: '',
    el: null,
    returnFocus: null,
    get hidden() { return !this.el || this.el.hidden; },

    open: function (added, error) {
      var self = this;
      if (!this.el) return;
      this.added = added || '';
      return getCart().then(function (cart) {
        self.cart = cart;
        self.render(error);
        if (self.el.hidden) {
          self.returnFocus = document.activeElement;
          self.el.hidden = false;
          document.documentElement.classList.add('cys-popup-open');
          self.el.querySelector('.cys-popup__panel').focus();
          trackView(self);
        }
      });
    },

    close: function () {
      if (!this.el || this.el.hidden) return;
      this.el.hidden = true;
      document.documentElement.classList.remove('cys-popup-open');
      // Shop Extras marks the body as "drawer open" (hides its sub-nav) when it adds; undo that.
      document.body.classList.remove('js-drawer-open', 'js-drawer-open-cart');
      seen.popup = null;
      if (this.returnFocus && this.returnFocus.focus) this.returnFocus.focus();
    },

    render: function (error) {
      var el = this.el, cart = this.cart;
      if (!el || !cart) return;
      var q = function (sel) { return el.querySelector(sel); };
      q('[data-cys-popup-title]').textContent = this.added ? 'Added: ' + this.added : (error ? 'Not added' : 'Your cart');
      q('[data-cys-popup-count]').textContent = cart.item_count + ' in cart · ' + money(cart.total_price);
      var threshold = parseInt(DATA.free_shipping, 10) || 7500;
      var gap = threshold - cart.total_price;
      q('[data-cys-popup-ship]').textContent = gap > 0 ? 'You’re ' + money(gap) + ' away from free shipping.' : 'You’ve got free shipping.';
      q('[data-cys-popup-bar]').style.width = Math.min(100, Math.round(cart.total_price / threshold * 100)) + '%';
      var err = q('[data-cys-error]');
      err.hidden = !error;
      err.textContent = error || '';

      var items = window.FlabUpsellRules.suggestions(cart, DATA, { soldOut: soldOut });
      this.items = items;
      q('[data-cys-rules]').hidden = items.length === 0;
      q('.cys__heading').textContent = window.FlabUpsellRules.heading(cart);
      var self = this;
      renderList(q('[data-cys-list]'), items, function (a, btn, position) { add(self, a, btn, position); });
      if (!el.hidden) trackView(this);
    }
  };

  window.FlabUpsell.openPopup = function (added, error) { popup.open(added, error); };

  var pending = null; // the add-to-cart form submitted last: { at, variantId, qty, title }

  function setupPopup() {
    popup.el = document.getElementById('CysPopup');
    if (!popup.el) return;
    popup.el.querySelectorAll('[data-cys-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () { popup.close(); });
    });
    popup.el.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') { popup.close(); return; }
      if (ev.key !== 'Tab') return;
      var f = Array.prototype.filter.call(popup.el.querySelectorAll('a[href], button:not([disabled])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
      else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
    });

    // Remember an add from any add-to-cart form (product pages, quick add, Shop Extras),
    // then show the pop-up when the theme tries to open the drawer for it.
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.getAttribute || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      var data = new FormData(form);
      pending = { at: Date.now(), variantId: Number(data.get('id')), qty: parseInt(data.get('quantity'), 10) || 1 };
    }, true);
    document.addEventListener('ajaxProduct:added', function (ev) {
      var item = ev.detail && ev.detail.product;
      if (pending && item && item.product_title) pending.title = item.product_title;
    });

    // assets/cart.js defines <cart-drawer> after this script runs, so wrap show() once it's ready.
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.customElements) return;
    customElements.whenDefined('cart-drawer').then(function () { wrapShow(drawer); });
  }

  function wrapShow(drawer) {
    if (typeof drawer.show !== 'function') return;
    var show = drawer.show;
    drawer.show = function () {
      if (variant() === 'popup' && pending && Date.now() - pending.at < 15000) {
        var p = pending;
        pending = null;
        document.body.classList.remove('js-drawer-open', 'js-drawer-open-cart');
        getCart().then(function (cart) {
          var line = cart.items.filter(function (i) { return i.variant_id === p.variantId; })[0] || cart.items[0];
          var title = p.title || (line && line.product_title) || '';
          popup.open(p.qty > 1 ? p.qty + ' × ' + title : title);
        });
        return;
      }
      return show.apply(this, arguments);
    };
  }

  function boot() { watchDrawer(); setupPopup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
